import { formatPostData } from './methods/format-post-data'
import { fetchPosts, fetchPostDetail } from './methods/fetch-posts'
import { fetchComments } from './methods/fetch-comments'

/**
 * Fetch post by ID
 * @param {string|number} postId - Post ID
 * @returns {Promise<Object>} Post data
 */
const fetchPost = async (postId) => {
  try {
    const response = await fetchPostDetail(postId)
    return response
  } catch (error) {
    console.error('Error in fetchPost service:', error)
    return null
  }
}

/**
 * Publish a post
 * @param {Object} params - Post publishing parameters
 * @returns {Promise<boolean>} Success status
 */
const publishPost = async (params) => {
  try {
    // Implementation will be added here
    console.log('Publishing post with params:', params)
    return true
  } catch (error) {
    console.error('Error publishing post:', error)
    return false
  }
}

/**
 * Posts service provides methods for working with social media posts
 */
export const postsService = {
  formatPostData,
  fetchPosts,
  fetchPostDetail,
  fetchPost,
  publishPost,
  fetchComments
}

export {
  formatPostData,
  fetchPosts,
  fetchPostDetail,
  fetchPost,
  publishPost,
  fetchComments
}
